import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  CircularProgress,
  Divider,
  Grid,
  Backdrop,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { useSetMember } from "../misc/utils";
import payCodeLogo from "../assets/payCodeLogo.png";
import PayMeLogoWeb from "../assets/payme_logo_color_oneline.png";
import ConfirmationModal from "../component/ConfirmationModal";
import SucessModal from "../component/SucessModal";
import QRCode from "react-qr-code";
import { useLocation, useNavigate } from "react-router-dom";
import Countdown from "../component/Countdown";
import { useAws } from "../aws";

const Payment = () => {
  const [data, setData] = useState(undefined);
  const { awsHttp } = useAws();
  const [orderDetails, setOrderDetails] = useState();
  const { t } = useTranslation();
  const mem = useSetMember();
  const [memberType, setMemberType] = useState(mem.getMember());
  const { x_api_key, apiStage, accessKey, secretKey } = useAws();
  const [qrString, setQrString] = useState("");
  const navigate = useNavigate();
  const [payMeFlag, setPayMeFlag] = useState(false);
  const paymeLogoImgElement = useRef("");
  const payCodeCanvas = useRef("");
  const [isLoading, setIsLoading] = useState(false);
  const [paymentId, setPaymentID] = useState("");
  const [price, setPrice] = useState("");
  const [isPaying, setIsPaying] = useState(false);
  const [confirmedPayment, setConfirmedPayment] = useState(false);
  const [enrolmentSuccess, setEnrolmentSuccess] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const state = useLocation().state;
  const paymentDate = orderDetails
    ? new Date(orderDetails?.create_time)
    : new Date();
  const txId = orderDetails
    ? orderDetails.purchase_units[0].payments.captures[0].id
    : "";
  useEffect(() => {
    const unloadCallback = (event) => {
      event.preventDefault();
      event.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", unloadCallback);
    return () => window.removeEventListener("beforeunload", unloadCallback);
  }, []);

  useEffect(() => {
    window.history.replaceState({}, document.title);
  }, []);
  const converTime = (ms) => {
    let s = ms / 1000;
    let secs = s % 60;
    s = (s - secs) / 60;
    var mins = s % 60;
    return (
      mins.toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      secs.toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })
    );
  };
  useEffect(() => {
    setData(() => {
      return JSON.parse(window.sessionStorage.getItem("event"));
    });
  }, []);

  const processEventEnrollmentData = (data) => {
    const trial = data?.option?.trial ? true : false;
    const p = {
      event_id: data.event_id,
      detail: {
        name: {
          prefix: data.prefix,
          en_full_name: data.parentname,
        },
        child_full_name: data.IDname,
        child_other_name: data.othername,
        gender: data.gender,
        contact_email: data.confirmEmail,
        contact_phone: data.phoneNumber,
        emergency_contact_phone_number: data.emergencyContactPhoneNumber,
        emergency_contact_full_name: data.emergencyname,
        birth_date: data.date,
        supporting_doc: data?.files?.length
          ? data.files.map((file) => file.data.filename)
          : [],
      },
      sku: data.skuIndex,
      option: data.optionIndex,
      promo_terms: data["pi-0"] ? "yes" : "no",
      film_terms: data["pi-1"] ? "yes" : "no",
      payment_method: data.paymentMethod,
      class_type:
        trial === true
          ? "trial"
          : data.option.memberStatus === "special"
          ? "special"
          : "normal",
      member_status: memberType,
      promo_code: data.promo_code,
    };

    return p;
  };
  useEffect(() => {
    if (data !== undefined) {
      handleEventEnrollment();
    }
  }, [data]);
  if (!state?.passed) {
    if (!data) return;
    navigate(`../../${data.event_id}`);
  }
  const handleEventEnrollment = () => {
    axios
      .post(
        apiStage +
          (data.paymentMethod == "PAY at SITE"
            ? "/user/payment/pay_at_site"
            : "/user/payment/paypal/pay"),
        processEventEnrollmentData(data),
        {
          headers: {
            secretKey: secretKey,
            accessKey: accessKey,
            "x-api-key": x_api_key,
            "Content-Type": "application/json",
          },
        }
      )
      .then((payment) => {
        if (payment.data.statusCode === 200) {
          if (data.NN2C) {
            if (window.location.href.includes("/payment")) {
              setEnrolmentSuccess(true);
              // navigate(`/result/2430e09`);
            }
            return;
          }
          if (!payment?.data?.body) {
            return;
          }
          const { txnRef, qrCode, pId } = payment?.data?.body || {};
          setPaymentID(payment.data.body);
          awsHttp({
            HTTPRequestMethod: "POST",
            APIFunction: "/user/payment/get_price",
            requestBody: {
              id: payment.data.body,
            },
          })
            .then((res) => {
              setPrice(res.data.body.price);
            })
            .catch(async (err) => {
              await awsHttp({
                HTTPRequestMethod: "POST",
                APIFunction: "/user/payment/force_fail",
                requestBody: {
                  id: payment.data.body,
                },
              });
              navigate(`/result/failed`);
            });

          // participantIdRef.current = payment.data.body;
          if (data.paymentMethod === "PayMe") {
          } else if (data.paymentMethod === "FPS") {
            setQrString(qrCode);
          }
        } else {
          awsHttp({
            HTTPRequestMethod: "POST",
            APIFunction: "/user/payment/fail",
            requestBody: {
              // spread existing details object
              phone_number: data.phoneNumber, // add pId property
              child_name: data.IDname,
            },
          }).then((res) => {});
          navigate(`/result/failed`);
        }
      });
  };

  const createOrder = (data, actions) => {
    setPaymentMethod(data.paymentSource);
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: price,
            currency_code: "HKD",
          },
        },
      ],
    });
  };

  const onApprove = (data, actions) => {
    setIsLoading(true);
    setIsPaying(true);
    return actions.order.capture().then(function (details) {
      setOrderDetails({ ...details });
      awsHttp({
        HTTPRequestMethod: "POST",
        APIFunction: "/user/payment/paypal/update_status",
        requestBody: {
          ...details, // spread existing details object
          pId: paymentId, // add pId property
        },
      }).then((res) => {
        setIsLoading(false);
        if (res.data.result === "true") {
          // navigate(`/result/2430e0`);
          setConfirmedPayment(true);
        } else {
          setIsPaying(false);

          awsHttp({
            HTTPRequestMethod: "POST",
            APIFunction: "/user/payment/force_fail",
            requestBody: {
              // spread existing details object
              id: paymentId,
            },
          }).then((res) => {});

          navigate(`/result/failed`);
        }
      });
    });
  };

  const onError = (data, actions) => {
    console.error(actions);
    setIsPaying(false);
  };

  const addZero = (val) => {
    if (val.toLocaleString().length === 1) {
      return "0" + val;
    } else return val;
  };
  if (!data) return;
  return (
    <div className="page-view-2 event-detail">
      <ConfirmationModal
        open={confirmedPayment}
        date={paymentDate.toLocaleDateString()}
        time={
          addZero(paymentDate.getHours()) +
          ":" +
          addZero(paymentDate.getMinutes()) +
          ":" +
          addZero(paymentDate.getSeconds())
        }
        eventId={data ? data.event_id : ""}
        skuName={data ? data.skuName : ""}
        price={price || ""}
        txId={txId}
        paymentName={
          orderDetails
            ? orderDetails.payer.name.given_name +
              " " +
              orderDetails.payer.name.surname
            : ""
        }
        paymentMethod={paymentMethod}
        phoneNumber={data ? data.phoneNumber : ""}
        paymentEmail={orderDetails ? orderDetails.payer.email_address : ""}
      />
      <SucessModal
        open={enrolmentSuccess}
        eventId={data ? data.event_id : ""}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <form style={{ position: "relative", marginTop: 32 }}>
        {/* <img
          className="logo logo-absolute"
          src="/EP_logo_withwords-01.png"
          alt="pause-and-breathe-logo"
        /> */}
        <div
          className={`card-view card-view-2 donation-card donation-result-card`}
          style={{ marginBottom: "40px" }}
        >
          {data.paymentMethod === "PayMe" ? (
            <img src={PayMeLogoWeb} width="250"></img>
          ) : null}
          {data.NN2C || data.paymentMethod != "FPS" ? null : (
            <h1 className="mt-2 mb-1 ml-2">{t("FPS Payment")}</h1>
          )}
          {data.NN2C || data.paymentMethod != "Card" ? null : (
            <div className="containerTimer">
              <h1 className="mt-2 mb-1 ml-2">{t("Card Payment")}</h1>
              <Countdown
                minutes={10}
                seconds={0}
                isPaying={isPaying}
                eventId={data ? data.event_id : ""}
              />
            </div>
          )}
          {data.NN2C ? null : (
            <h4 className="ml-2">
              {data.paymentMethod == "FPS"
                ? t("QR code title")
                : data.paymentMethod == "PayMe"
                ? t("PayCode title")
                : t("Card title")}
            </h4>
          )}

          {data.paymentMethod === "PayMe" ? (
            <img
              ref={paymeLogoImgElement}
              src={payCodeLogo}
              width="100"
              height="100"
              style={{ display: "none" }}
            />
          ) : null}
          <div className="paymentBox">
            <canvas
              ref={payCodeCanvas}
              width="344"
              height="344"
              style={payMeFlag ? {} : { display: "none" }}
            ></canvas>
            {data.paymentMethod == "Card" ? (
              <div style={{ width: 330 }}>
                <PayPalButtons
                  disabled={!paymentId && !price}
                  forceReRender={[price]}
                  fundingSource="paypal"
                  createOrder={createOrder}
                  onApprove={onApprove}
                  onError={onError}
                />
                <Divider sx={{ paddingBlock: 1 }}>OR</Divider>
                <PayPalButtons
                  disabled={!paymentId && !price}
                  forceReRender={[price]}
                  fundingSource="card"
                  createOrder={createOrder}
                  onApprove={onApprove}
                  onError={onError}
                />
              </div>
            ) : (
              <>
                {payMeFlag === false && qrString === "" ? (
                  <div className="centered">
                    <CircularProgress sx={{ margin: "20px 0" }} />
                    {data.NN2C ? null : (
                      <h4>
                        {data.paymentMethod == "FPS"
                          ? t("Please wait FPS")
                          : t("Please wait PayMe")}
                      </h4>
                    )}
                  </div>
                ) : (
                  <>
                    <div>
                      {data.paymentMethod == "FPS" ? (
                        <QRCode
                          size={1024}
                          style={{
                            height: "auto",
                            maxWidth: "100%",
                            width: "100%",
                          }}
                          value={qrString}
                          viewBox={`0 0 1024 1024`}
                        />
                      ) : (
                        // <QRCode size={1024} style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        // value={qrString} viewBox={`0 0 1024 1024`} fgColor="#c92a23"/>
                        // <canvas ref={payCodeCanvas} width="344" height="344"></canvas>
                        <></>
                      )}
                    </div>
                    <></>
                    {data.paymentMethod == "FPS" ? (
                      <>
                        <div className="info-block">
                          <h4>{t("Don't close")}</h4>
                        </div>
                        <div className="list-block">
                          <ol>
                            <li>{t("QR payment 1")}</li>
                            <li>
                              <div>
                                {t("QR payment 2")}
                                <br />
                                <span className="info-text">
                                  {t("QR payment 2 info")}
                                </span>
                              </div>
                            </li>
                            <li>
                              <div>
                                {t("QR payment 3")}
                                <br />
                                <span className="info-text">
                                  {t("QR payment 3 info")}
                                </span>
                              </div>
                            </li>
                          </ol>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="info-block">
                          <h4>{t("Don't close")}</h4>
                        </div>
                        <div className="list-block">
                          <ol>{t("QR payment 0 PayMe")}</ol>
                          <ol>
                            <li>{t("QR payment 1 PayMe")}</li>
                            <li>
                              <div>{t("QR payment 2 PayMe")}</div>
                            </li>
                            <li>
                              <div>{t("QR payment 3 PayMe")}</div>
                            </li>
                          </ol>
                        </div>
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {data !== undefined && data.paymentMethod !== "PAY at SITE" && (
              <>
                <div className="priceBox">
                  <div style={{ padding: 20 }}>
                    <h2 style={{ fontSize: 18 }}> Checkout</h2>
                    <div className="priceBox_textBox">
                      <div className="priceBox_smBox">
                        <p className="priceBox_text">Subtotal</p>
                        <p className="priceBox_price">
                          HK$
                          {!price
                            ? ""
                            : data.promoMoney
                            ? price + data.promoMoney
                            : price}
                        </p>
                      </div>
                      <div className="priceBox_smBox">
                        <p className="priceBox_text">Promo Value</p>
                        <p className="priceBox_price">
                          HK$
                          {!price
                            ? "..."
                            : data.promoMoney
                            ? data.promoMoney
                            : "Not applicable"}
                        </p>
                      </div>

                      <div className="priceBox_smBox">
                        <p className="priceBox_text">Payee</p>
                        <p className="priceBox_price">MyGym Premium</p>
                      </div>
                      <div className="priceBox_smBox">
                        <p className="priceBox_text" style={{ color: "black" }}>
                          <b>Order Total</b>
                        </p>
                        <p className="priceBox_price">
                          <b>HK${price}</b>
                        </p>
                      </div>
                    </div>
                  </div>
                  <Divider />
                  <div style={{ padding: 20 }}>
                    <div className="grid_flex">
                      <div className="grid_flex_1">Item</div>
                      <div className="grid_flex_2">QTY</div>
                      <div className="grid_flex_3">Price</div>
                    </div>
                    <Divider sx={{ marginBlock: 2 }} />
                    <div className="grid_flex">
                      <div className="grid_flex_1">
                        <p style={{ marginBlock: 5 }}> {data.event_id} </p>
                        <p>{data.skuName}</p>
                      </div>
                      <div className="grid_flex_2">1</div>
                      <div className="grid_flex_3">
                        HK${price !== "" ? price : "..."}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className={`my-5 btns-gp-div`}></div>
      </form>
    </div>
  );
};

export default Payment;
